import React from 'react';
import PropTypes from 'prop-types';
import Pagination from './Pagination';
import TopicsList from './TopicsList';
import SearchItem from './SearchItem';
import Sort from './Sort';

const SearchList = ({ posts }) => {
    if (posts.docs) {
        
        posts.to = Math.min(posts.to, posts.hit_num);

        return (
            <>
            <TopicsList topics={posts.topics} words={posts.words}/>
            <div className="SearchNumArea cFix">
                <Sort posts={posts}/>
                <p id="SearchNum">
                    <em>{posts.hit_num}</em>件中<em>{posts.from}～{posts.to}</em>件表示
                </p>
            </div>
                    
            <div id="SearchWeb" className="Section">
                <ul className="ListBlock" id="SiteSearchResult">
                    { posts.docs.map((post, index) => <SearchItem key={index} {...post} highlightwords={posts.highlightwords} sort={posts.sort}/>)}
                </ul>
                <div className="Section">
                    <Pagination />
                </div>
            </div>
            </>
            );
    }
    return null;
}

SearchList.propTypes = {
    posts: PropTypes.shape({
        docs: PropTypes.array.isRequired,
        words: PropTypes.string.isRequired,
        sort: PropTypes.string.isRequired,
        hit_num: PropTypes.string.isRequired,
        from: PropTypes.string.isRequired,
        to: PropTypes.string.isRequired,
        paging: PropTypes.object.isRequired,
        prev: PropTypes.string,
        pages: PropTypes.object.isRequired,
        next: PropTypes.object,
        highlightwords: PropTypes.array.isRequired,
        topics: PropTypes.array.isRequired,
    }).isRequired
}

export default SearchList;